<template>
  <date-picker
    v-slot="{ dateValue, minDate }"
    v-bind="$attrs"
    ref="datePicker"
    v-model="localValue"
    :date-string-append="dateStringAppend"
    :format-string-append="formatStringAppend"
    hide-details="auto"
    :menu-props="menuProps"
    placeholder="Select date & time"
    @closed="cancel"
  >
    <div class="py-6 qtm-border bg-white">
      <div class="d-flex pl-6">
        <div>
          <div class="mb-4 qtm-h4 text-secondary">
            Select date
          </div>
          <v-date-picker
            border
            color="primary"
            hide-header
            :min="minDate"
            :model-value="dateValue"
            @update:model-value="dateSelected"
          />
          <qtm-checkbox
            class="mt-4"
            label="I don't know date & time yet"
            :model-value="localDeliveryTime === 'tbd'"
            @update:model-value="toggleTbd"
          />
        </div>
        <div class="pl-4 flex-grow-1">
          <div class="mb-4 qtm-h4 text-secondary">
            Select time
          </div>
          <div class="overflow-y-auto pr-4" style="height: 450px">
            <order-delivery-time v-model="localValue" v-model:delivery-time="localDeliveryTime" />
          </div>
        </div>
      </div>
      <v-divider class="my-4" />
      <div class="px-6 text-right">
        <qtm-btn tertiary size="x-large" @click="cancel">
          Cancel
        </qtm-btn>
        <qtm-btn :disabled="!canApply" size="x-large" @click="apply">
          Apply
        </qtm-btn>
      </div>
    </div>
  </date-picker>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import DatePicker from '@/components/date-picker.vue'
import OrderDeliveryTime from '@/components/orders/order-delivery-time.vue'
import { DELIVERY_DATE_REQUIRED_VALUES } from '~/constants'

const timeStringFormat = 'h:mm A'

export default {
  name: 'order-delivery-date',
  components: { DatePicker, OrderDeliveryTime },
  props: {
    datePickerMenuProps: {
      type: Object,
      default: undefined
    },
    deliveryTime: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pickup: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      default: undefined
    },
  },
  emits: ['update:delivery-time', 'update:model-value'],
  data() {
    return {
      localDeliveryTime: this.deliveryTime,
      localValue: cloneDeep(this.modelValue),
    }
  },
  computed: {
    canApply() {
      return ['hold', 'tbd'].includes(this.localDeliveryTime)
        || (this.localValue && DELIVERY_DATE_REQUIRED_VALUES.includes(this.localDeliveryTime))
    },
    dateStringAppend() {
      if (this.localValue && (this.localDeliveryTime === 'am' || this.localDeliveryTime === 'pm')) {
        return ` ${this.timeString}`
      }
      if (this.localDeliveryTime === 'tbd') {
        return "Don't know date & time yet"
      }
      return ''
    },
    deliveryOrPickup() {
      return this.pickup ? 'pick-up' : 'delivery'
    },
    formatStringAppend() {
      if (this.localDeliveryTime === 'sp') {
        return `, ${timeStringFormat}`
      }
      return ''
    },
    menuProps() {
      return {
        closeOnContentClick: false,
        maxWidth: 620,
        minWidth: 620,
        ...this.datePickerMenuProps,
      }
    },
    timeString() {
      if (this.localValue) {
        if (this.localDeliveryTime === 'am') {
          return 'Morning'
        }

        if (this.localDeliveryTime === 'pm') {
          return 'Afternoon'
        }

        if (this.localDeliveryTime === 'sp') {
          return this.localValue.format(timeStringFormat)
        }
      }

      return 'Pick a Time'
    }
  },
  watch: {
    modelValue() {
      this.localValue = cloneDeep(this.modelValue)
    }
  },
  methods: {
    apply() {
      this.$emit('update:model-value', cloneDeep(this.localValue))
      this.$emit('update:delivery-time', this.localDeliveryTime)
      this.reset()
    },
    cancel() {
      this.localValue = cloneDeep(this.modelValue)
      this.localDeliveryTime = this.deliveryTime
      this.reset()
    },
    dateSelected(value) {
      if (value) {
        this.$refs.datePicker.setValue(value)

        if (['hold', 'tbd'].includes(this.localDeliveryTime)) {
          this.localDeliveryTime = ''
        }
      }
    },
    reset() {
      this.$refs.datePicker.close()
    },
    toggleTbd(value) {
      if (value) {
        this.localDeliveryTime = 'tbd'
        this.localValue = null
      }
      else {
        this.localDeliveryTime = ''
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.separation-text {
  border-bottom: 1px solid rgb(var(--v-theme-light-grey));
  text-align: center;
  height: 0.8em;
  margin-bottom: 0.5em;
}

.separation-text span {
  background: white;
  padding: 0 5px;
  font-weight: bold;
}
</style>
